module.exports = __webpack_public_path__ + "img/deskshelf08.3355d968.jpg";